<div class="bd-bottom p-3 bg-white">
  <h4 class="font-weight-bold text-color-2" i18n>Dodaj druge usluge</h4>
</div>

<div class="p-3">
  <app-cart class="mb-3"></app-cart>
</div>
